import { useEffect, useContext } from 'react';
import { AuthContext } from '../../logic';
import { getUser } from '../../api';

const useUser = (): void => {
	const { user, token, uid, setUser } = useContext(AuthContext);

	const onUserInit = async () => {
		const user = await getUser({ token, uid });
		setUser(user);
	};

	useEffect(() => {
		!user && token && onUserInit();
	}, [user, token]);
};

export { useUser };
